import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card'
import { Progress } from '@/components/ui/Progress'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/Table'
import { count, money } from '@/lib'
import type { IapPack } from '@/models'

export function PacksTable({ packs }: { packs: readonly IapPack[] }) {
  return (
    <Card>
      <CardHeader>
        <div className="min-w-0">
          <CardTitle>Packs Performance</CardTitle>
          <CardDescription>Revenue and unit distribution by product pack.</CardDescription>
        </div>
      </CardHeader>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Pack</TableHead>
            <TableHead className="text-right">Price</TableHead>
            <TableHead className="text-right">Units</TableHead>
            <TableHead className="text-right">Revenue</TableHead>
            <TableHead>Share</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {packs.map((pack) => (
            <TableRow key={pack.id}>
              <TableCell className="font-medium">{pack.name}</TableCell>
              <TableCell className="text-fg-muted text-right tabular-nums">{pack.price}</TableCell>
              <TableCell className="text-fg-muted text-right tabular-nums">
                {count(pack.units)}
              </TableCell>
              <TableCell className="text-right font-medium tabular-nums">
                {money(pack.revenue, true)}
              </TableCell>
              <TableCell>
                <span className="flex items-center gap-2">
                  <Progress value={pack.share} max={40} className="w-20" />
                  <span className="text-fg-subtle text-sm tabular-nums">{pack.share}%</span>
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}
